import { Paper } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Cookies from 'js-cookie';
import Link from 'next/link';
import React, { useMemo } from 'react';
import { LANG_DEFAULT } from 'sysconfig';
import PaymentMethodMobile from './PaymentMethodMobile';
import PaymentMethodWeb from './PaymentMethodWeb';
import styles from './styles.module.css';

const MissingUserInformation = ({ user, translateCheckout }) => {
  const { wardCode = '', districtCode = '', provinceCode = '' } = user;

  return (
    (!wardCode || !districtCode || !provinceCode) && (
      <Alert severity="info" style={{ borderRadius: '8px', marginTop: '15px' }}>
        {translateCheckout('please_enter_full')} {!wardCode && translateCheckout('ward')}
        {!districtCode && `, ${translateCheckout('district')}`}
        {!provinceCode && `, ${translateCheckout('province')}`} {translateCheckout('in')}{' '}
        <b>
          <Link href="/my-account">
            <a href="/my-account" target="_blank">
              {translateCheckout('account_info')}
            </a>
          </Link>
        </b>{' '}
        {translateCheckout('to_get_discount')}
      </Alert>
    )
  );
};

const PaymentMethod = ({
  handleChange,
  selectedPayment = '',
  paymentMethods = [],
  paymentMethodDefault,
  user,
  translateCheckout,
  isMobile = false,
}) => {
  const locale = Cookies.get('NEXT_LOCALE') || LANG_DEFAULT;

  // Get information's of selected payment method
  const selectedPaymentCode = useMemo(
    () => selectedPayment || paymentMethodDefault?.code || '',
    [selectedPayment, paymentMethodDefault?.code],
  );
  const selectedPaymentMethod = useMemo(
    () => paymentMethods?.find((method) => method.code === selectedPaymentCode) || {},
    [paymentMethods, selectedPaymentCode],
  );
  const {
    description,
    errorMessage,
    name: defaultName,
    subTitle: defaultSubTitle,
    currency: currencyOptions,
  } = selectedPaymentMethod || {};
  const selectedPaymentName = useMemo(
    () => selectedPaymentMethod?.[`name_${locale}`] ?? defaultName ?? '',
    [selectedPaymentMethod, defaultName, locale],
  );
  const selectedPaymentSubTitle = useMemo(
    () => selectedPaymentMethod?.[`subTitle_${locale}`] ?? defaultSubTitle ?? '',
    [selectedPaymentMethod, defaultSubTitle, locale],
  );

  return (
    <Paper className={styles.root} elevation={4}>
      {isMobile ? (
        <PaymentMethodMobile
          translateCheckout={translateCheckout}
          paymentMethods={paymentMethods}
          selectedVal={selectedPaymentCode}
          handleChange={handleChange}
          locale={locale}
          selectedPaymentName={selectedPaymentName}
          selectedPaymentSubTitle={selectedPaymentSubTitle}
          selectedPaymentMethod={selectedPaymentMethod || {}}
        />
      ) : (
        <PaymentMethodWeb
          translateCheckout={translateCheckout}
          paymentMethods={paymentMethods}
          selectedVal={selectedPaymentCode}
          handleChange={handleChange}
          locale={locale}
          errorMessage={errorMessage}
          description={description}
        />
      )}
      <MissingUserInformation user={user} translateCheckout={translateCheckout} />
    </Paper>
  );
};

export default React.memo(PaymentMethod);
